import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <RankingSection />
        <CarouselSection />
        <AboutSection />
        <IndexSection />
        <CommentsSection />
        <UpdatesSection />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <TopicsSection />
        <CardsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}